module.exports = __webpack_public_path__ + "resources/img/img_rancher3.15b9e012a5ec5e761ceabda4bad39e3a.png";